export default "__VITE_ASSET__Bx8Vo8O0__"